import { useId } from 'react';
import { cn } from '../lib/utils';

const PATH_D =
  'M4753 8980 c-18 -10 -40 -31 -50 -47 -17 -26 -18 -105 -23 -1573 -5 -1441 -7 -1550 -24 -1620 -73 -306 -270 -559 -545 -699 -124 -63 -144 -69 -670 -206 -245 -64 -480 -130 -524 -147 -150 -58 -322 -195 -417 -333 -46 -66 -116 -219 -135 -294 -28 -108 -37 -280 -29 -561 7 -290 10 -306 67 -340 32 -20 70 -20 2472 -20 2401 0 2441 0 2472 20 70 42 68 26 67 510 -1 460 -7 545 -51 754 -42 202 -97 352 -211 576 -96 188 -172 363 -172 395 0 7 23 22 51 34 104 43 249 169 328 284 64 94 121 267 121 369 l0 57 48 6 c205 29 392 134 506 285 55 74 118 200 141 285 10 36 18 117 21 205 6 161 -2 192 -59 234 -28 21 -40 21 -633 24 l-604 3 0 847 c0 814 -1 849 -20 889 -11 25 -33 51 -52 63 -33 20 -48 20 -1038 20 -979 0 -1006 -1 -1037 -20z m1887 -825 l0 -585 -850 0 -850 0 0 585 0 585 850 0 850 0 0 -585z m0 -924 l0 -79 -72 -17 c-129 -29 -304 -104 -434 -186 l-61 -39 -567 0 -566 0 0 200 0 200 850 0 850 0 0 -79z m1295 -363 c-16 -133 -61 -234 -138 -316 -93 -97 -186 -136 -370 -154 -102 -10 -124 -15 -149 -36 -46 -39 -52 -59 -59 -207 -8 -165 -26 -225 -95 -321 -52 -74 -120 -131 -200 -169 -109 -52 -147 -55 -696 -55 l-508 0 0 126 c0 149 24 285 74 413 153 392 511 686 916 751 41 6 82 13 90 15 8 1 269 3 578 4 l564 1 -7 -52z m-2145 -216 c0 -1 -24 -35 -54 -75 -61 -82 -123 -188 -156 -264 l-22 -53 -309 0 -309 0 0 194 0 195 38 3 c46 4 812 4 812 0z m-314 -679 c-3 -16 -9 -103 -13 -195 l-6 -168 -285 0 -284 0 5 28 c29 134 36 180 42 265 l7 97 270 0 270 0 -6 -27z m1271 -698 c34 -103 54 -148 168 -376 63 -128 116 -249 138 -320 55 -174 54 -156 5 -164 -139 -23 -348 -118 -480 -218 l-78 -59 -106 89 c-58 48 -122 101 -142 118 -21 16 -131 109 -247 205 -515 431 -708 591 -815 679 -63 52 -122 100 -130 108 -12 11 116 13 824 11 l839 -3 24 -70z m-1912 -86 c44 -35 201 -165 350 -289 148 -124 382 -319 520 -434 137 -114 326 -272 419 -350 92 -77 177 -148 187 -156 17 -14 17 -17 -17 -70 -58 -89 -102 -194 -134 -318 l-11 -43 -53 43 c-30 24 -152 124 -271 223 -120 99 -257 212 -304 251 -47 38 -180 148 -296 243 -115 95 -329 270 -474 389 -145 120 -275 226 -288 237 l-25 21 110 109 c60 61 126 136 147 168 24 37 42 54 49 49 6 -5 47 -37 91 -73z m-745 -1119 l0 -670 -195 0 -195 0 2 617 3 618 150 40 c83 23 164 46 180 52 17 6 36 12 43 12 9 1 12 -139 12 -669z m630 299 c184 -150 360 -294 390 -319 57 -48 568 -469 698 -574 40 -32 75 -63 78 -67 3 -5 -332 -9 -765 -9 l-771 0 0 637 c0 605 1 635 18 621 9 -8 168 -138 352 -289z m-1278 -385 l2 -579 -428 -3 -428 -2 5 262 c5 294 14 347 84 480 72 138 231 274 371 318 81 25 386 108 390 105 1 -1 3 -262 4 -581z m3711 94 c4 -46 7 -217 7 -380 l0 -298 -385 0 c-212 0 -385 3 -385 8 0 4 9 43 19 87 73 301 312 550 613 639 129 38 124 40 131 -56z';

const GROUP_TRANSFORM = 'translate(-233.324 899.993) scale(0.1 -0.1)';

const PATH_BOX = { x: 2333, y: 3140, width: 5865, height: 5860 };

const OUTLINE_D = PATH_D.slice(0, PATH_D.indexOf(' m'));

const OUTLINE_LENGTH = 22018;

interface LogoProps {
  size?: number;
  className?: string;
  animate?: boolean;
}

export default function Logo({ size = 28, className, animate = false }: LogoProps) {
  const clipId = `logo-clip-${useId().replace(/[^a-zA-Z0-9]/g, '')}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 587 586"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <g
        transform={GROUP_TRANSFORM}
        fill="currentColor"
        stroke="none"
        className={cn(animate && 'animate-logo-fill')}
      >
        <path d={PATH_D} />
      </g>

      {animate && (
        <>
          <g transform={GROUP_TRANSFORM} fill="none" stroke="currentColor">
            <path
              className="animate-logo-trace"
              d={OUTLINE_D}
              strokeWidth="60"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeDasharray={OUTLINE_LENGTH}
            />
          </g>
          <defs>
            <clipPath id={clipId} clipPathUnits="userSpaceOnUse">
              <path d={PATH_D} />
            </clipPath>
          </defs>
          <g transform={GROUP_TRANSFORM} clipPath={`url(#${clipId})`}>
            <rect
              className="animate-logo-sheen"
              x={PATH_BOX.x}
              y={PATH_BOX.y - 200}
              width={PATH_BOX.width * 0.26}
              height={PATH_BOX.height + 400}
              fill="#fff"
              opacity="0"
            />
          </g>
        </>
      )}
    </svg>
  );
}
